import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FieldConfig } from '@smartflip/data-models';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'lib-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: false,
})
export class ButtonComponent implements OnInit {
  @Output() buttonClick: EventEmitter<MouseEvent> =
    new EventEmitter<MouseEvent>();
  field: FieldConfig;
  group: UntypedFormGroup;
  buttonType: string;

  handleClick(evt: MouseEvent) {
    this.buttonClick.emit(evt);
  }

  ngOnInit() {
    this.buttonType = this.field.buttonType;
  }
}
